import { useQuery } from '@tanstack/react-query';

import { getCsAgentRoster } from '~/services/CsDashboardService';

import { reportingQueryKeys } from './reportingQueryKeys';

// The roster is near-static (very irregular changes) and svc-reporting caches it for 12hrs
const ROSTER_STALE_TIME_MS = 60 * 60 * 1000;

export function useCsAgentRoster() {
  return useQuery({
    queryKey: reportingQueryKeys.csAgentRoster(),
    queryFn: ({ signal }) => getCsAgentRoster({ signal }),
    staleTime: ROSTER_STALE_TIME_MS,
  });
}
